import { Box, Text, HStack, Select } from '@chakra-ui/react'
import React, {FC, useState} from 'react'
import { useTranslation } from 'next-i18next'
import { PendantSide } from '_app/types/product'
import theme from 'theme'
import { ToggleEngravingProps } from './types'

export const ToggleEngraving: FC<ToggleEngravingProps> = ({
  pendantsOptions,
  activePendantId,
  setActivePendantId,
  activeSide,
  setActiveSide,
  activePendantIdx,
  setActivePendantIdx,
}) => {
  const { t } = useTranslation('product')
  const pendantsKeys = Object.keys(pendantsOptions)
  const isMultiple = pendantsKeys.length > 1
  const activePendant = pendantsOptions[activePendantId]
  const activeId = activePendantId + '|' + activeSide + '|' + activePendantIdx
  const [defaultValue] = useState(activeId)
  const options = pendantsKeys.map(id => {
    if (pendantsOptions[id].front?.length && pendantsOptions[id].back?.length) {
      return [
        {
          id: `${id}|front|${pendantsOptions[id].pendantIdx}`,
          name:
            pendantsOptions[id].name || pendantsOptions[id].front?.[0].title,
          side: {
            id: 'front',
            text: t('FRONT'),
            disabled: !activePendant?.front?.length,
            showSide: !!pendantsOptions[id].name,
          },
          front: pendantsOptions[id].front,
        },
        {
          id: `${id}|back|${pendantsOptions[id].pendantIdx}`,
          name: pendantsOptions[id].name || pendantsOptions[id].back?.[0].title,
          side: {
            id: 'back',
            text: t('BACK'),
            disabled: !activePendant?.back?.length,
            showSide: !!pendantsOptions[id].name,
          },
          back: pendantsOptions[id].back,
        },
      ]
    }
    if (pendantsOptions[id].front?.length) {
      return [
        {
          id: `${id}|front|${pendantsOptions[id].pendantIdx}`,
          name:
            pendantsOptions[id].name || pendantsOptions[id].front?.[0].title,
          side: {
            id: 'front',
            text: t('FRONT'),
            disabled: !activePendant?.front?.length,
            showSide: !!pendantsOptions[id].name,
          },
          front: pendantsOptions[id].front,
        },
      ]
    }
    if (pendantsOptions[id].back?.length) {
      return [
        {
          id: `${id}|back|${pendantsOptions[id].pendantIdx}`,
          name: pendantsOptions[id].name || pendantsOptions[id].back?.[0].title,
          side: {
            id: 'back',
            text: t('BACK'),
            disabled: !activePendant?.back?.length,
            showSide: pendantsOptions[id].showSide,
          },
          back: pendantsOptions[id].back,
        },
      ]
    }
  })

  const optionsKeys = Object.keys(options)

  const handleChangePendants = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const values = e.target.value.split('|')
    const activePendant = values[0]
    const side = values[1] as PendantSide
    setActivePendantId(activePendant)
    setActiveSide(side)
    setActivePendantIdx(Number(values[2]))
  }
  return (
    <Box width="100%" pl={0}>
      <Text
        display={isMultiple ? { base: 'flex', md: 'block' } : 'block'}
        fontWeight={300}
        fontSize={{ base: 'xs', md: 'md' }}
      >
        {t('ELEMENT', { ns: 'common' })}
      </Text>
      <HStack
        overflowX={{ md: 'auto' }}
        css={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
        ml="unset"
        width={{ base: '19rem', md: 'unset' }}
      >
        <Select
          value={activeId}
          name={activeId}
          onChange={(e) => handleChangePendants(e)}
          defaultValue={defaultValue}
          fontSize={{ md: 'md' }}
          sx={{
            borderWidth: '0 0 1px 0',
            borderColor: theme.colors.grey,
            borderRadius: 0,
            padding: '0 2rem 0 0',
            ':focus': {
              borderColor: theme.colors.grey,
            },
            ':hover': {
              borderColor: theme.colors.grey,
            },
          }}
        >
          {optionsKeys.map((id, index) =>
            options[index]?.map((option, indexOption) => (
              <option key={indexOption} value={option.id}>
                {option.side.showSide ? `${option.side.text} - ` : ''}
                {option.name ? option.name : ''}
              </option>
            ))
          )}
        </Select>
      </HStack>
    </Box>
  )
}
